module.exports = __webpack_public_path__ + "img/icon-vsq.4a58500a.svg";